import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { userCustodianDataService } from '../../../api';

export const fetchUserCustodianData = createAsyncThunk('user-custodian-data/find-by-id', (id: number) =>
  userCustodianDataService.findByUserId(id),
);

export const cleanUserCustodianData = createAction('user-custodian-data/clean');
